// reducers.js
import { SET_SCRAPING_DATA } from "../actionTypes";

const initialState = {
  isScraping: false,
};

const scrapingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SCRAPING_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default scrapingReducer;
